module.exports = __webpack_public_path__ + "static/media/139.d629ae76.jpg";